import './style.css';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

function Card({item, path}){
  return <Link to={`/${path}/${item.id}`}>
    <div className="card-wrapper" >
      <motion.div className="card-container" whileHover={{scale: 1.03, transition: { duration: 0.3 }}} whileTap={{scale: 0.97, transition: { duration: 0.3 }}}>
        <div className="card-image-container" style={item.title ? { height: '80%'} : {height: '100%'}}>
          <img src={item.image}/>
        </div>
        {item.title && <h3>{item.title}</h3>}
      </motion.div>  
    </div>
  </Link>
}

export default Card;